import { UserLoginDetail, UserLoginDetailTypeEnum } from '@jooxter/api';
import { CookieService } from '@jooxter/storage';

// Set on an OAuth logout, until the next explicit login. Kept out of the zustand persisted state: another
// tab still open writes that one back, the email with it, at its next store update.
export const LOGGED_OUT_COOKIE = 'logged-out';

export const markLoggedOut = () => CookieService.setCookie(LOGGED_OUT_COOKIE, 'true');

export const forgetLoggedOut = () => CookieService.deleteCookie(LOGGED_OUT_COOKIE);

/**
 * A session that could not be refreshed: an SSO user is signed back in silently, through their IdP. Not
 * after a logout, even if another tab restored their email: they go to the login page instead.
 */
export const shouldSignBackInWithSSO = (loginDetails?: UserLoginDetail | null): boolean =>
  !!loginDetails &&
  loginDetails.type !== UserLoginDetailTypeEnum.Jooxter &&
  !CookieService.getCookie(LOGGED_OUT_COOKIE);
